export const MAIN_PORTAL_INSTANCE_ID = "__main__"

export function isOnMainPortal(
	isVisible: boolean | null | undefined,
	portalInstanceIds: readonly string[] | null | undefined,
): boolean {
	if (!isVisible) return false
	const ids = portalInstanceIds ?? []
	return ids.length === 0 || ids.includes(MAIN_PORTAL_INSTANCE_ID)
}

export function isOnNamedPortal(
	isVisible: boolean | null | undefined,
	portalInstanceIds: readonly string[] | null | undefined,
	portalInstanceId: string,
): boolean {
	if (!isVisible) return false
	const ids = portalInstanceIds ?? []
	return ids.includes(portalInstanceId)
}

interface ChangelogPortalScope {
	portalInstanceId?: string | null
	portalInstanceIds?: readonly string[] | null
}

export function changelogPortalIds(entry: ChangelogPortalScope): string[] {
	const listed = entry.portalInstanceIds
	if (listed && listed.length > 0) return [...listed]
	return [entry.portalInstanceId ?? MAIN_PORTAL_INSTANCE_ID]
}
